import { api } from "./client";
import type { App } from "./apps.api";

export const meApi = {
  apps: () => api.get<App[]>("/me/apps").then((r) => r.data),
  reorderApps: (appIds: string[]) =>
    api.put<App[]>("/me/apps/order", { appIds }).then((r) => r.data),
  resetAppOrder: () =>
    api.delete<App[]>("/me/apps/order").then((r) => r.data),
};
